import { render, staticRenderFns } from "./CamiloDetails.vue?vue&type=template&id=14770176&scoped=true&"
import script from "./CamiloDetails.vue?vue&type=script&lang=js&"
export * from "./CamiloDetails.vue?vue&type=script&lang=js&"
import style0 from "./CamiloDetails.vue?vue&type=style&index=0&id=14770176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14770176",
  null
  
)

export default component.exports